import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import * as AdminActions from '../../../store/actions/adminActions';
import Boundary from '../../Boundary.js';
import Student from './Student';
import {WithContext as ReactTags} from "react-tag-input";
import DatePicker from "react-datepicker";
import {NotificationManager} from "react-notifications";

/* global $ */
const KeyCodes = {
    comma: 188,
    enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

class StudentSearch extends Component {
    constructor(props){
        super(props);

        this.state = {
            search: '',
            subjectId: '',
            courseIds: [],
            name: '',
            absent: 0,
            flags: '',
            testDate:  '',
            tags: []
        }

        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentDidMount(){
        this.init();
    }


    handleDelete(i) {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {
        this.setState(state => ({ tags: [...state.tags, tag] }));
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId || props.location.search !== this.props.location.search){
            this.init();
        }
    }

    init = () => {
        // console.log("Initting");
        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        this.setState({courseIds: courseIds});

        if(this.props.studentSubjects){
            if(this.props.studentSubjects.length === 0 && courseIds.length > 0){
                //this.props.getSubjectsByCourseId(courseIds, this.props.user.id);
            }
        }

        // Get search query:
        let s = this.props.location.search.substr(1);
        let apiQuery = {};
        let tags = [];

        s.split('&').map(q => {
            let localQ = q.split('=')[0];
            if (q.split('=')[0] === "tags") {
                tags = q.split('=')[1].split(',').map(t => {
                    return {
                        id: t,
                        text: t
                    }
                })
                return apiQuery[q.split('=')[0]] = q.split('=')[1].split(',');

            } else {
                if (q.split('=')[1] !== "Invalid date" && q.split('=')[1] !== "Invalid%20date") {
                    return apiQuery[q.split('=')[0]] = q.split('=')[1];
                }
            }
        })

        this.setState({tags: tags})

        // console.log("Got seearch", apiQuery);
        this.props.searchStudents(courseIds, 0, 10, apiQuery, this.props.user.user.id, this.props.user.id);

        //this.props.getStudents(courseIds, 0, 10, {}, this.props.user.user.id, this.props.user.id);
    }

    loadMore = () => {
        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        this.setState({courseIds: courseIds});

        if(this.props.studentSubjects){
            if(this.props.studentSubjects.length === 0 && courseIds.length > 0){
                //this.props.getSubjectsByCourseId(courseIds, this.props.user.id);
            }
        }

        // Get search query:
        let s = this.props.location.search.substr(1);
        let apiQuery = {};

        s.split('&').map(q => {
            let localQ = q.split('=')[0];
            if (q.split('=')[0] === "tags") {
                return apiQuery[q.split('=')[0]] = q.split('=')[1].split(',');
            } else {
                return apiQuery[q.split('=')[0]] = q.split('=')[1];
            }
        })

        // console.log("Got seearch", apiQuery);
        this.props.loadMoreStudents(courseIds, this.props.students.length, 10, apiQuery, this.props.user.user.id, this.props.user.id);
    }

    ToggleAdvanceSearch = (e) => {
        // console.log(e.currentTarget);
        var t = $(e.currentTarget).text();
        if(t=="Advanced Search"){
            $(e.currentTarget).text("Basic Search");
            $(".basic_search").stop().slideUp();
            $(".advnce_search").stop().slideDown();
        }else{
            $(e.currentTarget).text("Advanced Search");
            $(".basic_search").stop().slideDown();
            $(".advnce_search").stop().slideUp();
        }
        e.preventDefault();
    }

    initSearch = (e, mode) => {
        e.preventDefault();

        // Redirect to search page:
        let params = '';

        if (mode === 'name'){
            params = "?name=" + this.state.name;
        } else {

            Object.keys(this.state).filter(k => k !== 'name').map((k, i) => {
                if (this.state[k] !== '' && this.state[k] !== 0 && this.state[k] !== [] && this.state[k] !== "0" && k !== "courseIds" && k !== "tags" && k !== 'testDate') {
                    params += (params === '') ? '?' : '&';
                    params += k + "=" + this.state[k];
                    return params;
                } else if (k === "tags") {
                    let tagString = "";
                    for (let i = 0; i < this.state.tags.length; i++) {
                        if (i === 0) {
                            tagString += this.state.tags[i].text;
                        } else {
                            tagString += "," + this.state.tags[i].text;
                        }
                    }


                    if (tagString !== '') {
                        params += (params === '') ? '?' : '&';
                        params += k + "=" + tagString;
                    }
                    return params;
                } else if (k === 'testDate'){

                    if (moment(this.state.testDate).format('YYYY-MM-DD') !== "Invalid date") {
                        params += (params === '') ? '?' : '&';
                        params += k + "=" + moment(this.state.testDate).format('YYYY-MM-DD');

                        return params;
                    }
                }else{
                    return null;
                }
            });
        }
        this.props.history.push(`${this.props.match.url}${params}`);
    }



    render(){
        return (
            <div>
                <div className="panel customPanel panel-advanced-search">
                    <div className="panel-heading border-bottom">
                        <h3 className="panel-title">Search</h3>
                    </div>
                    <div className="panel-body super-dark-panel" style={{background: '#191919'}}>
                        <div className="basic_search" style={{display: 'block'}}>
                             <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label>Search Student By Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="StudentName"
                                            value={this.state.name}
                                            onChange={e => this.setState({name: e.target.value})}
                                            onKeyUp={e => {
                                                if(e.keyCode === 13){
                                                    this.initSearch(e, 'name');
                                                }
        }}
                                            />

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="advnce_search" style={{display: 'none'}}>
                            <div className="row">
                                <div className="col-sm-2">
                                    <div className="form-group">
                                        <label>Current Subject</label>
                                        <div className="form-select-overlay">
                                            <select
                                                className="form-control"
                                                    value={this.state.subjectId}
                                                    onChange={e => this.setState({subjectId: e.target.value})}
                                                    >
                                                <option value="">All</option>
                                                {this.props.studentSubjects ?
                                                    this.props.studentSubjects.map((sub, i) => {
                                                        return <option value={sub.id}>{sub.name}</option>
                                                    })
                                                : null}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="form-group">
                                        <label>Absent For</label>
                                        <div className="form-select-overlay">
                                            <select className="form-control"
                                                value={this.state.absent}
                                                onChange={e => this.setState({absent: e.target.value})}
                                                >
                                                <option value="0">All</option>
                                                {Array(30).fill().map((_, i) => {
                                                    return (
                                                        <option value={i}>{i === 0 ? "Any" : `${i} days`}</option>
                                                    )
                                                })}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="form-group">
                                        <label>Flags</label>
                                        <div className="form-select-overlay">
                                            <select
                                                className="form-control"
                                                    value={this.state.flags}
                                                    onChange={e => this.setState({flags: e.target.value})}>
                                                <option value="">All</option>
                                                <option value="red">Red Flag</option>
                                                <option value="yellow">Yellow Flag</option>
                                                <option value="orange">Orange Flag</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="form-group">
                                        <label>Test Date <span className="required">* </span></label>
                                        <DatePicker
                                        selected={this.state.testDate ? moment(this.state.testDate) : undefined}
                                        name="access"
                                        className="form-control"
                                        onChange={e => {
                                                this.setState({testDate: e});
                                        }
                                    }
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={15}
                                        />
                                        <i className="zmdi zmdi-calendar"></i>
                                        <span className="help-block"></span>
                                    </div>
                                </div>

                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label>Tags</label>
                                        <ReactTags tags={this.state.tags}
                                            classNames={{
                                                tags: 'ReactTags__tags form-control',
                                            }}
                                            handleDelete={this.handleDelete}
                                            handleAddition={this.handleAddition}
                                            handleDrag={this.handleDrag}
                                            delimiters={delimiters} />
                                </div>


                            </div>
                            <div className="col-sm-1">
                                <div className="form-group">
                                <label>&nbsp;</label>
                            <div>
                            <button className="btn btn-default btn-icon" onClick={e => this.initSearch(e, 'advanced')}><i className="fa fa-search"></i></button>
                            </div>
                            </div>
                            </div>
                        </div>
                        </div>

                        <div className=""><a href="#" onClick={e => this.ToggleAdvanceSearch(e)}>Advanced Search</a></div>

                    </div>
                </div>
            </div>
            
        )
    }
}

const withRouterAndRef = (WrappedComponent) => {
    class InnerComponentWithRef extends React.Component {
        render() {
            const { forwardRef, ...rest } = this.props;
            return <WrappedComponent {...rest} ref={forwardRef} />;
        }
    }
    const ComponentWithRouter = withRouter(InnerComponentWithRef, { withRef: true });
    return React.forwardRef((props, ref) => {
        return <ComponentWithRouter {...props} forwardRef={ref} />;
    });
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getStudents: (courseIds, filter, userId, token) => {
        dispatch(AdminActions.getStudents(courseIds, filter, userId, token));
    },
    getSubjectsByCourseId: (courseIds, token) => {
        dispatch(AdminActions.getStudentSubjects(courseIds, token));
    },
    searchStudents: (courseIds, skip, limit, query, userId, token) => {
        dispatch(AdminActions.searchStudents(courseIds, skip, limit, query, userId, token));
    },
    loadMoreStudents: (courseIds, skip, limit, query, userId, token) => {
        dispatch(AdminActions.loadMoreStudents(courseIds, skip, limit, query, userId, token));
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(StudentSearch));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Students/StudentSearch.js